import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const TokenAuth = () => {
  const navigate = useNavigate();
  const authToken = process.env.AUTH_TOKEN;

  useEffect(() => {
    const authyToken = localStorage.getItem(authToken);
    if (authyToken !== null) {
      try {
        const decodedToken = jwtDecode(authyToken);
        const expirationTime = decodedToken.exp * 1000;
        const currentTime = Date.now();
        if (currentTime > expirationTime) {
          localStorage.removeItem(authyToken);
        //   window.location.href = '/login';
          navigate('/login');
        }
      } catch (error) {
        console.error('Invalid token:', error);
        localStorage.removeItem(authyToken);
        // window.location.href = '/login';
        navigate('/login');
      }
    } else {
      navigate('/login'); // Redirect if no token is found
    }
  }, [navigate]);

  return null;
};

export default TokenAuth;
